import { FaHourglassStart } from 'react-icons/fa';
import { SpinIndicator } from './SpinIndicator';

export const HourGlassSpinIndicator = (props) =>
  SpinIndicator({ component: FaHourglassStart, ...props });
